import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=1e673492&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=ts"
export * from "./PageView.vue?vue&type=script&lang=ts"
import style0 from "./PageView.vue?vue&type=style&index=0&id=1e673492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e673492",
  null
  
)

export default component.exports